/* SessionTextTransition.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._3iDTPbkfkE%7Bdisplay%3Ainline-grid%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._4ouGXIdnbC%7Bmin-width%3A0%7D%0A._1RrJLiUWqv%7Bvertical-align%3Abottom%7D%0A._0pI6nMF05b%7Bjustify-items%3Aend%7D%0A._2iEGP20MSB%7Bgrid-template-columns%3Aminmax(0%2C1fr)%20auto%7D%0A._1xC2CJIjUK%7Bgrid-area%3A1%2F2%7D%0A._0LQT5E1Y8M%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D%0A._03SyCP1Y8M%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._1xC2CJYhv7%7Bgrid-area%3A1%2F1%7D%0A._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D%0A%40keyframes%20k1m8j3od%7B0%25%7Bopacity%3A1%7Dto%7Bopacity%3A0%7D%7D%0A._1gBibyfsJg%7Banimation-name%3Ak1m8j3od%7D%0A._0nFVCGecFN%7Banimation-duration%3A.36s%7D%0A._43vdfTjwM9%7Banimation-timing-function%3Avar(--ds-easing-out-practical%2Ccubic-bezier(.4%2C1%2C.6%2C1))%7D%0A._3Y6bKpgRhm%7Banimation-fill-mode%3Aforwards%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._39Ohv4YbGa%7Banimation%3Anone%7D._3NPCoqYbGa%7Bdisplay%3Anone%7D%7D%0A%40keyframes%20k91lto4%7B0%25%7Bopacity%3A0%3Btransform%3AtranslateY(9pt)%7Dto%7Bopacity%3A1%3Btransform%3AtranslateY(0)%7D%7D%0A._1gBibyZ5U1%7Banimation-name%3Ak91lto4%7D%0A._0nFVCGQnJB%7Banimation-duration%3A.48s%7D%0A._1jakNnwPCu%7Banimation-delay%3A.28s%7D%0A._3Y6bKpZSoF%7Banimation-fill-mode%3Aboth%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._39Ohv4YbGa%7Banimation%3Anone%7D%7D");


























import React, { type ReactNode, useEffect, useState } from 'react';
import { cx } from '@atlaskit/css';
import { useIsReducedMotion } from '@atlaskit/motion/use-is-reduced-motion';
import { useResizing } from '@atlaskit/motion/use-resizing';
import { Box } from '@atlaskit/primitives/compiled/box';
const fadeOut = null;
const slideIn = null;
const styles = {
  viewport: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbkfkE _0hPCNLDIqT _4ouGXIdnbC _1RrJLiUWqv",
  alignEnd: "_0pI6nMF05b",
  withSeparator: "_2iEGP20MSB",
  separator: "_1xC2CJIjUK _0LQT5E1Y8M _03SyCP1Y8M _3YEZNOdnbC",
  layer: "_1xC2CJYhv7 _3iDTPbccYA _0hPCNLDIqT _4ouGXIdnbC _1ANEUSLRg7",
  outgoing: "_1gBibyfsJg _0nFVCGecFN _43vdfTjwM9 _3Y6bKpgRhm _39Ohv4YbGa _3NPCoqYbGa",
  incoming: "_1gBibyZ5U1 _0nFVCGQnJB _1jakNnwPCu _43vdfTjwM9 _3Y6bKpZSoF _39Ohv4YbGa"
};

/** Match Jira's label motion while smoothly releasing the outgoing label's width. */
export const SessionTextTransition = ({
  align = 'start',
  children,
  transitionKey,
  shouldAnimateOnMount,
  trailingSeparator = false,
  onExitComplete
}: {
  align?: 'start' | 'end';
  children: ReactNode;
  transitionKey: string | undefined;
  shouldAnimateOnMount: boolean;
  trailingSeparator?: boolean;
  onExitComplete?: () => void;
}): React.JSX.Element => {
  const reducedMotion = useIsReducedMotion();
  const content = children;
  const [transition, setTransition] = useState({
    key: transitionKey,
    current: content,
    outgoing: (null as ReactNode),
    occurrence: 0,
    animate: shouldAnimateOnMount
  });
  if (transition.key !== transitionKey) {
    setTransition({
      key: transitionKey,
      current: content,
      outgoing: transition.current,
      occurrence: transition.occurrence + 1,
      animate: true
    });
  }
  useEffect(() => {
    if (!transition.outgoing) {
      return;
    }
    // Release the old width as soon as its fade ends, during the incoming slide.
    const timeout = setTimeout(() => {
      setTransition(previous => ({
        ...previous,
        outgoing: null
      }));
    }, reducedMotion ? 0 : 360);
    return () => clearTimeout(timeout);
  }, [transition.occurrence, transition.outgoing, reducedMotion]);
  const resizing = useResizing({
    dimension: 'width',
    duration: "var(--ds-duration-medium, 200ms)",
    easing: "var(--ds-easing-out-practical, cubic-bezier(0.4, 1, 0.6, 1))",
    onFinishMotion: () => {
      if (!children && !transition.outgoing) {
        onExitComplete?.();
      }
    }
  });
  useEffect(() => {
    if (reducedMotion && !children && !transition.outgoing) {
      onExitComplete?.();
    }
  }, [children, transition.outgoing, reducedMotion, onExitComplete]);
  return <Box as="span" ref={resizing.ref} xcss={cx(styles.viewport, align === 'end' && styles.alignEnd, trailingSeparator && styles.withSeparator)}>
			{transition.outgoing ? <Box as="span" xcss={cx(styles.layer, styles.outgoing)} aria-hidden>
					{transition.outgoing}
				</Box> : null}
			{content ? <Box key={transition.occurrence} as="span" xcss={cx(styles.layer, transition.animate && styles.incoming)}>
					{content}
				</Box> : null}
			{trailingSeparator && (content || transition.outgoing) ? <Box as="span" xcss={styles.separator}>
					·
				</Box> : null}
		</Box>;
};